// REM7 Collection 2027 — owner-supplied copy. No numeric specs (none verified).
export type C26Lang = "en" | "es";
export interface C26Copy { kicker: string; tagline: string; copy: string; features: string[] }
export interface C26Product { slug: string; name: string; images: string[]; en: C26Copy; es: C26Copy }

// Hero first, then gallery photos g1..gN in numeric order (hero is not repeated).
const imgs = (slug: string, n: number) => [
  `/images/collection-2027/${slug}-hero.jpg`,
  ...Array.from({ length: n }, (_, i) => `/images/collection-2027/${slug}-g${i + 1}.jpg`),
];

export const collection2026: C26Product[] = [
  {
    slug: "132-the-sculpture", name: "REM7 132 · The Sculpture", images: imgs("132-the-sculpture", 8),
    en: {
      kicker: "One-piece · Ovoid form",
      tagline: "A sculpture first. An intelligent toilet second.",
      copy: "A seamless ovoid in gloss white, the 132 reads as an object of design before it reveals its purpose. The lid rises in one fluid motion, while discreet side controls and a slender stainless wash wand keep the silhouette pure and uninterrupted.",
      features: ["Ovoid one-piece silhouette in gloss white", "Automatic lid opening", "Discreet side-mounted control buttons", "Slim stainless wash wand"],
    },
    es: {
      kicker: "Monobloque · Forma ovoide",
      tagline: "Primero una escultura. Después, un inodoro inteligente.",
      copy: "Un ovoide continuo en blanco brillante: el 132 se percibe como un objeto de diseño antes de revelar su función. La tapa se eleva en un único movimiento fluido, mientras los discretos mandos laterales y una fina cánula de lavado de acero inoxidable mantienen la silueta pura e ininterrumpida.",
      features: ["Silueta ovoide monobloque en blanco brillante", "Apertura automática de la tapa", "Discretos botones de control laterales", "Fina cánula de lavado de acero inoxidable"],
    },
  },
  {
    slug: "153-midnight-edition", name: "REM7 153 · Midnight Edition", images: imgs("153-midnight-edition", 8),
    en: {
      kicker: "One-piece · Ambient light",
      tagline: "Low, tailored and lit from within.",
      copy: "Low-slung and tailored, the 153 comes in pure white for light-filled rooms and deep black for dramatic interiors. At night a soft ambient glow beneath the seat shifts through warm and cool tones.",
      features: ["White and black finishes", "Multi-colour ambient bowl lighting", "Illuminated control panel on the lid", "Compact, low one-piece profile"],
    },
    es: {
      kicker: "Monobloque · Luz ambiental",
      tagline: "Bajo, a medida e iluminado desde dentro.",
      copy: "De perfil bajo y líneas precisas, el 153 está disponible en blanco puro para estancias luminosas y en negro profundo para interiores con carácter. De noche, un suave resplandor bajo el asiento pasa por tonos cálidos y fríos.",
      features: ["Acabados en blanco y negro", "Iluminación ambiental multicolor en la taza", "Panel de control iluminado en la tapa", "Perfil monobloque bajo y compacto"],
    },
  },
  {
    slug: "158a-suspended", name: "REM7 158A · Suspended", images: imgs("158a-suspended", 7),
    en: {
      kicker: "Wall-hung · Concealed cistern",
      tagline: "Floating clear of the floor.",
      copy: "Designed for architecture that values the clean line: a slim, flat lid with an integrated control strip, a precise stainless wash wand and an open floor beneath for effortless cleaning. Wall-hung installation keeps the room visually larger, ideal for villas, boutique hotels and design-led apartments.",
      features: ["Wall-hung with open floor beneath", "Flat slim lid with integrated control strip", "Stainless wash wand", "Top-access foam-fluid compartment"],
    },
    es: {
      kicker: "Suspendido · Cisterna empotrada",
      tagline: "Flotando sobre el suelo.",
      copy: "Pensado para una arquitectura que valora la línea limpia: tapa plana y fina con franja de control integrada, una precisa cánula de lavado de acero inoxidable y el suelo libre debajo para una limpieza sin esfuerzo. La instalación suspendida hace que el baño parezca más amplio, ideal para villas, hoteles boutique y apartamentos de diseño.",
      features: ["Suspendido, con el suelo libre debajo", "Tapa plana y fina con franja de control integrada", "Cánula de lavado de acero inoxidable", "Depósito de líquido espumante con acceso superior"],
    },
  },
  {
    slug: "m86-monolith", name: "REM7 M86 · Monolith", images: imgs("m86-monolith", 5),
    en: {
      kicker: "One-piece · Architectural form",
      tagline: "Squared, architectural and utterly calm.",
      copy: "A white monolith with a slim illuminated display and integrated side controls, designed for spaces where every line is considered. Crisp edges, a contrasting grey base band and a soft blue light line give it a presence closer to architecture than sanitary ware.",
      features: ["Squared one-piece form", "Illuminated digital display on the lid", "Integrated side controls", "Contrasting base band with blue accent light"],
    },
    es: {
      kicker: "Monobloque · Forma arquitectónica",
      tagline: "Cuadrado, arquitectónico y absolutamente sereno.",
      copy: "Un monolito blanco con una fina pantalla iluminada y mandos laterales integrados, diseñado para espacios donde cada línea está pensada. Aristas nítidas, una banda inferior gris en contraste y una suave línea de luz azul le dan una presencia más cercana a la arquitectura que a la sanitaria.",
      features: ["Forma monobloque cuadrada", "Pantalla digital iluminada en la tapa", "Mandos laterales integrados", "Banda inferior en contraste con luz de acento azul"],
    },
  },
];

export const c26Lang = (language: string): C26Lang => (language === "es" ? "es" : "en");
